import React from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Swal from 'sweetalert2';
import { API_URL } from '../../Constants';
import { axiosClient, axiosClientCloud} from '../AxiosClient';


const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

export default function CommerceForm() {

    let apiUrl = API_URL;

    const handleOnClickFeasibilityForm = () => {
        let name = document.getElementById("clientName").value;
        let lastName = document.getElementById("clientLastName").value;
        const documentType = documentTypes.find(res => res.label === document.getElementById("clientDocumentType").value).value;
        let documentNumber = document.getElementById("clientDocumentNumber").value;
        let cellphone = document.getElementById("clientCellphone").value;
        let email = document.getElementById("clientEmail").value;
        let ageRange = document.getElementById("clientAgeRange").value;

        if (name === "" || lastName === "" || documentType === "" || documentNumber === "") {
            alert("Revisa los campos obligatorios")
        } else {
            let client = { name: name, lastName: lastName, documentType: documentType, documentNumber: documentNumber, cellphone: cellphone, ageRange: ageRange, email: email }
            createFeasibilityStudy(client)
        }
    }

    const createFeasibilityStudy = (client) => {
        let feasibility = { client: client, commerceUuid: localStorage.getItem('commerceUuid') }
        axiosClientCloud.post('/v1/feasibility-inquiries', feasibility)
        .then(response => {
            console.log(response.data.uuid);
            showSuccessCreated();
        })
        .catch(error => {
            if (error.response && error.response.status === 422) {
                showExistingFeasibility();
            } else {
                alert("Por favor contacte al administrador");
            }
            console.log('Hubo un problema con la petición Axios:' + error.message);
        });
    }
    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }


    function showSuccessCreated() {

        Swal.fire({
            icon: 'success',
            title: 'Solicitud Realizada!',
            showConfirmButton: false,
            timer: 1500
        });
        sleep(1500).then(() => {
            window.location = '/commerce';
        })
    }

    function showExistingFeasibility() {

        Swal.fire({
            title: 'Ya existe un crédito pendiente para este cliente!',
            showDenyButton: true,
            showCancelButton: true,
            showDenyButton: false,
            confirmButtonText: 'ir a créditos en proceso',
            denyButtonText: `Don't save`,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                window.location = '/inprocess-credits';
            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info');
            }
        })
    }

    const documentTypes = [
        { label: 'Cedula de Ciudadanía', value: 'CC' },
        { label: 'Cedula de extranjería', value: 'CE' },
        { label: 'NIT', value: 'NIT' }
    ];

    const handleBackToHome = () => {
        window.location = '/commerce';
    }
    return (
        <React.Fragment>
            <Header />
            <Container maxWidth="md">
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={6}>
                            <Stack spacing={4.5}>
                                <TextField required id="clientName" label="Ingrese Nombre(s)" variant="outlined" />
                                <TextField required id="clientLastName" label="Ingrese Apellido(s)" variant="outlined" />
                                <TextField id="clientAgeRange" label="Ingrese Edad" variant="outlined" />
                                <Autocomplete
                                    disablePortal
                                    id="clientDocumentType"
                                    options={documentTypes}
                                    defaultValue={documentTypes[0]}
                                    renderInput={(params) => <TextField {...params} required label="Tipo de Documento" />}
                                />
                                <TextField required id="clientDocumentNumber" label="Ingrese Numero de Documento" variant="outlined" />
                                <TextField id="clientCellphone" label="Ingrese Numero de celular" variant="outlined" />
                                <TextField id="clientEmail" label="Ingrese Correo Electronico / Email" variant="outlined" />
                                <Stack spacing={2} direction="row">
                                    <ButtonPrincipal variant="contained" onClick={handleBackToHome}>Volver</ButtonPrincipal>
                                    <ButtonPrincipal variant="contained" onClick={handleOnClickFeasibilityForm}>Enviar solicitud</ButtonPrincipal>
                                </Stack>

                            </Stack>
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
}